"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
// Original Enum: Microsoft.Exchange.Clients.Owa2.Server.Core.AttachmentDataProviderType
var AttachmentDataProviderType;
(function (AttachmentDataProviderType) {
    AttachmentDataProviderType[AttachmentDataProviderType["OneDrivePro"] = 0] = "OneDrivePro";
    AttachmentDataProviderType[AttachmentDataProviderType["OneDriveConsumer"] = 1] = "OneDriveConsumer";
    AttachmentDataProviderType[AttachmentDataProviderType["Dropbox"] = 2] = "Dropbox";
    AttachmentDataProviderType[AttachmentDataProviderType["Box"] = 3] = "Box";
    AttachmentDataProviderType[AttachmentDataProviderType["Mailbox"] = 4] = "Mailbox";
    AttachmentDataProviderType[AttachmentDataProviderType["GDrive"] = 5] = "GDrive";
    AttachmentDataProviderType[AttachmentDataProviderType["Facebook"] = 6] = "Facebook";
    AttachmentDataProviderType[AttachmentDataProviderType["WopiBox"] = 7] = "WopiBox";
    AttachmentDataProviderType[AttachmentDataProviderType["WopiEgnyte"] = 8] = "WopiEgnyte";
    AttachmentDataProviderType[AttachmentDataProviderType["WopiDropbox"] = 9] = "WopiDropbox";
    AttachmentDataProviderType[AttachmentDataProviderType["MailMessage"] = 10] = "MailMessage";
})(AttachmentDataProviderType || (AttachmentDataProviderType = {}));
exports.default = AttachmentDataProviderType;
